import React from 'react'
import { NavLink } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faChartLine,
    faChevronCircleUp,
    faChevronCircleDown,
    faCogs,
} from '@fortawesome/pro-duotone-svg-icons'
import { adminPermissions } from '../../Admin/Pages/Roles/roles.utils.ts'

class AdminMainMenu extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            displayAdminSettings: false,
        }

        this.handleAdminSettings = this.handleAdminSettings.bind(this)
        this.hasPermissions = this.hasPermissions.bind(this)
    }

    handleAdminSettings() {
        this.setState((state) => ({
            displayAdminSettings: !state.displayAdminSettings,
        }))
    }

    hasPermissions() {
        if (this.props.kedo.isAdminOrEnvironmentAdmin()) {
            return true
        }

        const credentials = this.props.kedo.env().environment.credentials || []

        return adminPermissions.some((permission) =>
            credentials.some((cred) => cred.startsWith(permission.key))
        )
    }

    render() {
        const kedo = this.props.kedo

        return (
            <nav className="dropdown MainMenu" aria-label="Admin Navigation">
                <ul style={{ background: 'none', borderTop: 'none' }}>
                    <li
                        className={'menu-item avLinkStyle'}
                        onClick={this.props.close}
                    >
                        <NavLink
                            activeClassName="selectedLink"
                            className={'menuHeadItem dashboard navLinkStyle'}
                            key={'dashboard'}
                            exact
                            to={`/`}
                        >
                            <FontAwesomeIcon icon={faChartLine} /> &nbsp;{' '}
                            {kedo.t('Dashboard')}
                        </NavLink>
                    </li>
                </ul>
                {this.hasPermissions() ? (
                    <div
                        onClick={this.handleAdminSettings}
                        className={'menuHeadItem navLinkStyle admin'}
                    >
                        <FontAwesomeIcon icon={faCogs} />
                        &nbsp; {kedo.t('Admin settings')}
                        <FontAwesomeIcon
                            icon={
                                this.state.displayAdminSettings
                                    ? faChevronCircleUp
                                    : faChevronCircleDown
                            }
                            className={'dropArrow float-right'}
                        />
                    </div>
                ) : null}
                {this.state.displayAdminSettings ? (
                    <ul onClick={() => window.scrollTo(0, 0)}>
                        {kedo.hasPermissionFor('kedo.env') && (
                            <li onClick={this.props.close}>
                                <NavLink
                                    to={'/environment/edit'}
                                    className={'MainMenuLink navLinkStyle'}
                                    activeClassName="selectedLink"
                                >
                                    {kedo.t('Generic')}
                                </NavLink>
                            </li>
                        )}
                        {kedo.hasPermissionFor('kedo.datastructure') && (
                            <li onClick={this.props.close}>
                                <NavLink
                                    to={'/datastructure'}
                                    className={'MainMenuLink navLinkStyle'}
                                    activeClassName="selectedLink"
                                >
                                    {kedo.t('Datastructures')}
                                </NavLink>
                            </li>
                        )}
                        {kedo.hasPermissionFor('kedo.erd') && (
                            <li onClick={this.props.close}>
                                <NavLink
                                    to={'/erd'}
                                    className={'MainMenuLink navLinkStyle'}
                                    activeClassName="selectedLink"
                                >
                                    {kedo.t('ERD')}
                                </NavLink>
                            </li>
                        )}
                        {/*<NavLink to={'/layout'} className={"MainMenuLink"} activeClassName="selectedLink">*/}
                        {/*    <li onClick={this.props.close}>{kedo.t('Layout')}</li>*/}
                        {/*</NavLink>*/}
                        {kedo.hasPermissionFor('kedo.role.index') && (
                            <li onClick={this.props.close}>
                                <NavLink
                                    to={'/roles'}
                                    className={'MainMenuLink navLinkStyle'}
                                    activeClassName="selectedLink"
                                >
                                    {kedo.t('Roles')}
                                </NavLink>
                            </li>
                        )}

                        {kedo.hasPermissionFor('kedo.defdossierpermission') && (
                            <li onClick={this.props.close}>
                                <NavLink
                                    to={'/permissions'}
                                    className={'MainMenuLink navLinkStyle'}
                                    activeClassName="selectedLink"
                                >
                                    {kedo.t('Permissions')}
                                </NavLink>
                            </li>
                        )}
                        {kedo.hasPermissionFor('kedo.logs') && (
                            <li onClick={this.props.close}>
                                <NavLink
                                    to={'/logs'}
                                    className={'MainMenuLink navLinkStyle'}
                                    activeClassName="selectedLink"
                                >
                                    {kedo.t('Logs')}
                                </NavLink>
                            </li>
                        )}
                        {kedo.hasPermissionFor('kedo.useractivity') && (
                            <li onClick={this.props.close}>
                                <NavLink
                                    to={'/useractivity'}
                                    className={'MainMenuLink navLinkStyle'}
                                    activeClassName="selectedLink"
                                >
                                    {kedo.t('User activity')}
                                </NavLink>
                            </li>
                        )}
                        {kedo.hasPermissionFor('kedo.file.index') && (
                            <li onClick={this.props.close}>
                                <NavLink
                                    to={'/files'}
                                    className={'MainMenuLink navLinkStyle'}
                                    activeClassName="selectedLink"
                                >
                                    {kedo.t('Files')}
                                </NavLink>
                            </li>
                        )}
                        {/*<NavLink to={'/backups'} className={"MainMenuLink  navLinkStyle"} activeClassName="selectedLink">*/}
                        {/*    <li onClick={this.props.close}>{kedo.t('Backups')}</li>*/}
                        {/*</NavLink>*/}
                        {kedo.hasPermissionFor('kedo.user.index') && (
                            <li onClick={this.props.close}>
                                <NavLink
                                    to={'/user'}
                                    className={'MainMenuLink navLinkStyle'}
                                    activeClassName="selectedLink"
                                >
                                    {kedo.t('Users')}
                                </NavLink>
                            </li>
                        )}
                        {kedo.hasPermissionFor('kedo.locale.index') && (
                            <li onClick={this.props.close}>
                                <NavLink
                                    to={'/languages'}
                                    className={'MainMenuLink navLinkStyle'}
                                    activeClassName="selectedLink"
                                >
                                    {kedo.t('Languages')}
                                </NavLink>
                            </li>
                        )}
                        {kedo.hasPermissionFor('kedo.mypageblocks.index') && (
                            <li onClick={this.props.close}>
                                <NavLink
                                    to={'/blocks'}
                                    className={'MainMenuLink navLinkStyle'}
                                    activeClassName="selectedLink"
                                >
                                    {kedo.t('Blocks')}
                                </NavLink>
                            </li>
                        )}
                        {kedo.hasPermissionFor('kedo.module.index') && (
                            <li onClick={this.props.close}>
                                <NavLink
                                    to={'/modules'}
                                    className={'MainMenuLink navLinkStyle'}
                                    activeClassName="selectedLink"
                                >
                                    {kedo.t('Modules')}
                                </NavLink>
                            </li>
                        )}
                        {kedo.hasPermissionFor('kedo.event.index') && (
                            <li onClick={this.props.close}>
                                <NavLink
                                    to={'/events'}
                                    className={'MainMenuLink navLinkStyle'}
                                    activeClassName="selectedLink"
                                >
                                    {kedo.t('Events')}
                                </NavLink>
                            </li>
                        )}
                        {kedo.hasPermissionFor('kedo.kedocx.index') && (
                            <li onClick={this.props.close}>
                                <NavLink
                                    to={'/wordkedocx'}
                                    className={'MainMenuLink navLinkStyle'}
                                    activeClassName="selectedLink"
                                >
                                    {kedo.t('Kedocx')}
                                </NavLink>
                            </li>
                        )}
                        {kedo.hasPermissionFor('kedo.querybuilder') && (
                            <li onClick={this.props.close}>
                                <NavLink
                                    to={'/querybuilder'}
                                    className={'MainMenuLink navLinkStyle'}
                                    activeClassName="selectedLink"
                                >
                                    {kedo.t('Querybuilder')}
                                </NavLink>
                            </li>
                        )}
                        {/*<NavLink to={'/reports'} className={"MainMenuLink  navLinkStyle"} activeClassName="selectedLink">*/}
                        {/*    <li onClick={this.props.close}>Reports</li>*/}
                        {/*</NavLink>*/}
                        {kedo.hasPermissionFor('kedo.webhooks.index') && (
                            <li onClick={this.props.close}>
                                <NavLink
                                    to={'/webhooks'}
                                    className={'MainMenuLink navLinkStyle'}
                                    activeClassName="selectedLink"
                                >
                                    {kedo.t('Webhooks')}
                                </NavLink>
                            </li>
                        )}
                    </ul>
                ) : null}
            </nav>
        )
    }
}

export default AdminMainMenu
